import React from 'react';
import { inventoryTableData } from '../../Data';

function DeviceMonitoring() {
  return (
    <div className="relative m-2 w-full ml-20 px-1">
      <div className="h-36 bg-activeIcon px-16 pt-3 flex mt-2">
        <span className="text-white font-bold text-lg mt-5 w-full">Device Monitoring</span>

        <div className="flex justify-between w-full">
          <div className=" relative rounded-md font-medium border h-10 w-60 mt-2.5 pr-3 ml-8">
            <label htmlFor="customers" className="block text-white bg-activeIcon absolute px-2 text-sm left-3 -top-2.5">
              Customers
            </label>
            <select
              id="customers"
              className="rounded-md px-4 py-3 bg-transparent h-10 focus:outline-none w-full text-white text-xs"
            >
              <option value="All" className="fy-4">
                All
              </option>
            </select>
          </div>

          <div className="h-14 mt-1 w-px bg-gray-400 mx-20" />

          <div className="relative rounded-md font-medium border h-10 w-60 mt-2.5 pr-3">
            <label htmlFor="projects" className="block text-white bg-activeIcon absolute px-2 text-sm left-3 -top-2.5">
              Projects
            </label>
            <select
              id="projects"
              className="rounded-md px-4 py-3 bg-transparent h-10 focus:outline-none w-full text-white text-xs"
            >
              <option value="All" className="fy-4">
                All
              </option>
            </select>
          </div>

          <div className="h-14 mt-1 w-px bg-gray-400 mx-20" />

          <div className="relative rounded-md font-medium border h-10 w-60 mt-2.5 pr-3 flex justify-between">
            <input
              id="projects"
              type="text"
              placeholder="Enter Device Id"
              className="rounded-md px-4 py-1 bg-transparent h-10 focus:outline-none w-full text-white text-sm"
            />
            <img src="assets/img/Search_white.svg" className="w-3" />
          </div>
        </div>
      </div>

      <div className=" w-full -mt-60">
        <div className="bg-tableBg w-tableWidth m-auto mb-3">
          <div className="bg-tableHeader w-full flex relative">
            <div className="px-6 flex w-full">
              <div className="w-1/4 py-5 text-center text-sm font-black">ASSIGNED</div>
              <div className="w-1/4 py-5 text-center text-sm font-black">COMPANY</div>
              <div className="w-1/4 py-5 text-center text-sm font-black">DEVICED</div>
              <div className="w-1/4 py-5 text-center text-sm font-black">DEVICE IDs</div>
              <div className="w-1/4 py-5 text-center text-sm font-black">LAST RETRIEVED</div>
              <img src="assets/img/Filter.svg" className="w-5 absolute top-5 right-3" />
            </div>
          </div>
          <div className="pb-1">
            {inventoryTableData.map((item) => (
              <div className="m-2.5 px-3.5 bg-white flex rounded-md shadow-sm relative">
                <input type="checkbox" className="absolute left-8 top-5" />
                <div className="text-role w-1/4 py-4 text-center text-sm font-bold flex justify-center uppercase">
                  {item.assigned}
                </div>
                <div className="text-role w-1/4 py-4 text-center text-sm font-bold uppercase">{item.company}</div>
                <div className="text-role w-1/4 py-4 text-center text-sm font-bold uppercase">{item.device}</div>
                <div className="text-role w-1/4 py-4 text-center text-sm font-bold uppercase">{item.id}</div>
                <div className="text-role w-1/4 py-4 text-center text-sm font-bold">{item.lastRetrieved}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeviceMonitoring;
